import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import getDetailLayout from './Layouts';

const DetailPicker = ({
  collection,
  refreshCollection,
  setActiveTabResourceType,
}) => {
  const headResource = collection.resources().head();
  const {
    Layout,
  } = getDetailLayout(headResource.type());

  // TODO: toggle DetailMobile Component here when needed.

  return (
    <Layout
      collection={collection}
      refreshCollection={refreshCollection}
      setActiveTabResourceType={setActiveTabResourceType}
    />
  );
};

DetailPicker.propTypes = {
  collection: PropTypes.object.isRequired,
  refreshCollection: PropTypes.func.isRequired,
  setActiveTabResourceType: PropTypes.func,
};
DetailPicker.defaultProps = {
  setActiveTabResourceType: noop,
};
export default DetailPicker;
